// #region Imports

/* Telestream */
import { ConnectionService } from '../../services/connection.service';
import { COLOR_PICKER_SWATCHES } from '@/utils/constants';

// #endregion Imports

// #region Fetch

export async function openClipLists(paths) {
  const connection = ConnectionService.getHubConnection(ConnectionService.getOrigin(), '/cliplists', false);
  await connection.start();

  try {
    const clips = await connection.invoke('OpenClipLists', paths);
    return clips;
  }

  catch (exception) {
    throw exception.message.split('HubException:').pop();
  }

  finally {
    connection.stop();
  }
}

// #endregion Fetch

// #region Constants

const COLORS_TOO_CLOSE = 0.15 * 360;
const COLOR_STEP = 360 / 4;

// #endregion Constants

// #region Property Generation

export function generateRandomClipColor(previous) {
  let hue = 360 * Math.random();
  if (previous) {
    const parts = previous.match(/[+-]?\d+(\.\d+)?/g);
    const previousHue = Number(parts[0]);

    const difference = Math.abs(hue - previousHue)
    if (difference < COLORS_TOO_CLOSE) {
      hue = (hue + (Math.random() + 1) * COLOR_STEP) % 360;
    }
  }

  return `hsl(${ hue },80%,${ 40 + (20 * Math.random()) }%)`;
}

export function generateRandomAnnotationColor(surroundingColors) {
  let flat = [].concat(...COLOR_PICKER_SWATCHES);
  let hsl = flat.map(x => HEXtoHSL(x));

  for (var i in surroundingColors) {
    let index = hsl.findIndex(color => color === surroundingColors[i]);
    if (index != -1) {
      hsl.splice(index, 1);
    }
  }

  return hsl[Math.floor(Math.random() * hsl.length)];
}

function HEXtoHSL(hex) {
  hex = hex.replace(/#/g, '');
  if (hex.length === 3) {
    hex = hex.split('').map(function (hex) {
      return hex + hex;
    }).join('');
  }
  var result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})[\da-z]{0,0}$/i.exec(hex);
  if (!result) {
    return null;
  }
  var r = parseInt(result[1], 16) / 255;
  var g = parseInt(result[2], 16) / 255;
  var b = parseInt(result[3], 16) / 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h, s, l = (max + min) / 2;
  if (max == min) {
    h = s = 0;
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
    case r:
      h = (g - b) / d + (g < b ? 6 : 0);
      break;
    case g:
      h = (b - r) / d + 2;
      break;
    case b:
      h = (r - g) / d + 4;
      break;
    }
    h /= 6;
  }
  s = Math.round(s * 100);
  l = Math.round(l * 100);
  h = Math.round(360 * h);

  return `hsl(${h},${s}%,${l}%)`;
}

// #endregion Property Generation

export function compressClipList(clips) {
  return clips.map(c => {
    return {
      path:      c.path,
      in:        c.in,
      out:       c.out,
      notes:     c.notes,
      framerate: c.framerate,
      dropframe: c.dropframe,
      offset:    c.offset
    }
  })
}